var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5928 21.6C6.09747 21.6 5.6748 21.4238 5.3248 21.0713C4.9748 20.7188 4.7998 20.295 4.7998 19.8V8.4C4.7998 7.905 4.97605 7.48125 5.32855 7.12875C5.68105 6.77625 6.1048 6.6 6.5998 6.6H8.3998V6.2C8.3998 5.2 8.7373 4.31667 9.4123 3.55C10.0873 2.78333 10.9498 2.4 11.9998 2.4C12.9998 2.4 13.8498 2.75 14.5498 3.45C15.2498 4.15 15.5998 5 15.5998 6V6.6H17.3998C17.8948 6.6 18.3186 6.77625 18.6711 7.12875C19.0236 7.48125 19.1998 7.905 19.1998 8.4V19.8C19.1998 20.295 19.0235 20.7188 18.6708 21.0713C18.3181 21.4238 17.8941 21.6 17.3988 21.6H6.5928ZM10.1998 6.6H13.7998V6C13.7998 5.505 13.6231 5.08125 13.2696 4.72875C12.9161 4.37625 12.4911 4.2 11.9946 4.2C11.4981 4.2 11.0748 4.37625 10.7248 4.72875C10.3748 5.08125 10.1998 5.505 10.1998 6V6.6ZM14.6946 10.8C14.9481 10.8 15.1623 10.7138 15.3373 10.5413C15.5123 10.3688 15.5998 10.155 15.5998 9.9V8.4H13.7998V9.9C13.7998 10.155 13.8856 10.3688 14.0571 10.5413C14.2286 10.7138 14.4411 10.8 14.6946 10.8ZM9.29455 10.8C9.54805 10.8 9.7623 10.7138 9.9373 10.5413C10.1123 10.3688 10.1998 10.155 10.1998 9.9V8.4H8.3998V9.9C8.3998 10.155 8.48555 10.3688 8.65705 10.5413C8.82855 10.7138 9.04105 10.8 9.29455 10.8Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping_bag.a82a677b5b79ce933df6564de48519f9.svg";
export { ForwardRef as ReactComponent };